import { Bolt } from './icons.js';

/**
 * The auto contract: a value is "auto" when it came from the system and has not been touched. The marker is
 * derived from the value's source, never a separate flag, so what Accept agrees to is unambiguous.
 */
export type ValueSource = 'auto' | 'user';

export function AutoMark({ source }: { source: ValueSource }) {
  if (source !== 'auto') return null;
  return (
    <span className="am" title="Filled by the system">
      <Bolt />
      auto
    </span>
  );
}

export function AutoPill({ children }: { children: React.ReactNode }) {
  return (
    <span className="auto">
      <Bolt />
      {children}
    </span>
  );
}
